import { useState, useRef } from "react";
import Select, { components } from "react-select";
import DirectoryCard from "../../../../components/Employee/EmployeeDirectoryCard";
import Search from "../../../../components/Header/Search/Search";
import {
  useEmployeeList,
  useGetLocationList,
  useGetDepartmentList,
  useGetDesignationList,
} from "../../../../queries/employeeQueries";
import useGetQueryParams from "../../../../hooks/useGetQueryParams";
import EmptyState from "../../../../components/EmptyState/EmptyState";
import PageLoader from "../../../../components/PageLoader/PageLoader";
import Pagination from "../../../../components/Pagination/Pagination";
import { employementStatus } from "../../../../utils/commonSelectBoxOptions/commonSelectBoxOptions";
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <span className="ico-down text-blue-600"></span>
    </components.DropdownIndicator>
  );
};

const isEmployeeDirectory = true; // Flag to fetch all employee  data for directory
const FILTER_CONSTS = {
  filter: "filter",
  accountStatus: "accountStatus",
  office: "office",
  designation: "designation",
  department: "department",
  pageSize: "pageSize",
  pageNo: "pageNo",
};
const defaultLocationOption = { location_name: "Office: All", id: null };
const defaultDesignationOption = {
  designation_title: "Designation: All",
  id: null,
};
const defaultDepartmentOption = {
  department_name: "Department: All",
  id: null,
};
const ActiveAccountStatus = 1

const filterInitialState = {
  filter: "",
  accountStatus: ActiveAccountStatus, // ACTIVE EMPLOYEE ACCOUNT STATUS (DEFAULT ON LOAD), WILL BE UPDATED BASED ON FILTERS
  office: "",
  designation: "",
  department: "",
  pageSize: "",
  pageNo: "",
};

const Directory = () => {
  localStorage.setItem("isContinue", "true");

  const selectBoxRef = useRef({
    "Employement Status": "",
    Ofiice: "",
    Department: "",
    Designation: "",
  });
  const searchBoxRef = useRef({});

  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [empFilters, setEmpFilters] = useState(filterInitialState);
// default account filters = 1(active) if update anu other filtes takes filter based on applied filter logic

const handleSetEmpFilter = (value, source) => {
  setEmpFilters((prev) => {
    const newFilters = {
      ...prev,
      [source]: value,
    };

    // If user changes anything other than accountStatus
    if (source !== FILTER_CONSTS.accountStatus) {
      const hasOtherFilters =
        newFilters.filter ||
        newFilters.office ||
        newFilters.designation ||
        newFilters.department;

      if (hasOtherFilters) {
        // Remove account status filter if using other filters
        newFilters.accountStatus = "";
      } else {
        // No other filters? Default to "Active"
        newFilters.accountStatus = ActiveAccountStatus;
      }
    }

    return newFilters;
  });
};




  const { searchQuery, pageNo, pageSize, setPageNo, setPageSize } =
    useGetQueryParams(
      {
        ...empFilters,
        sortOrder: "DESC",
        isEmployeeDirectory,

       
      },
      "pageNo",
      "pageSize",
      {
        pageSize: 12,
      }
    );

  const {
    data: employeeData,
    isLoading: isEmployeeDataLoading,
    refetch: fetchEmployeeData,
  } = useEmployeeList(searchQuery);

  const { data: getLocationList } = useGetLocationList();
  const { data: getDepartmentList } = useGetDepartmentList();
  const { data: getDesignationList } = useGetDesignationList();

  const locationList = Array.isArray(getLocationList?.result)
    ? [defaultLocationOption, ...getLocationList?.result]
    : [];

  const totalRecords = employeeData?.totalRecords || 0;
  const employeeList = employeeData?.employee || null;

  const departmentList = Array.isArray(getDepartmentList?.result)
    ? [defaultDepartmentOption, ...getDepartmentList?.result]
    : [];

  const designationList = Array.isArray(getDesignationList?.result)
    ? [defaultDesignationOption, ...getDesignationList?.result]
    : [];

  const isFilterApplied =
  empFilters?.filter ||
  empFilters?.department ||
  empFilters?.designation ||
  empFilters?.office ||
  (empFilters?.accountStatus &&
    empFilters?.accountStatus !== filterInitialState.accountStatus);

const handleClearFilters = () => {
  const selectBoxRefKeys = Object.keys(selectBoxRef.current);
  selectBoxRefKeys.forEach((item) => {
    try {
      if (selectBoxRef?.current?.[item]) {
        if (item === "Employement Status") {
          selectBoxRef?.current?.[item]?.setValue({
            label: "Active",
            value: "1",
          });
        } else {
          selectBoxRef?.current?.[item]?.setValue({
            label: `${item}: All`,
            value: "",
          });
        }
      }
    } catch (e) {}
  });
  setEmpFilters(filterInitialState); // resets to Active
  if (searchBoxRef.current) {
    searchBoxRef.current.value = "";
  }
};


  const handleSelectEmployee = (employee, status) => {
    if (!employee && typeof status === "boolean") {
      if (status) {
        setSelectedEmployees(employeeList);
      } else {
        setSelectedEmployees([]);
      }
    } else if (employee) {
      if (status) {
        setSelectedEmployees((prev) => {
          const isExists = prev?.find(
            (i) => i?.employee_id === employee?.employee_id
          );
          if (isExists) {
            return prev;
          } else {
            return [...prev, employee];
          }
        });
      } else {
        setSelectedEmployees((prev) =>
          prev.filter((i) => i.employee_id !== employee.employee_id)
        );
      }
    }
  };

  return (
    <div className="w-full px-10 py-6 bg-gray-50">
      <div className="flex justify-between">
        <div>
          <h2>Employee Directory</h2>
          <p className="pb-4">View all employe on your ogranization</p>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex gap-3">
          {/* FILTERS */}
          <Select
            ref={(ele) => (selectBoxRef.current["Designation"] = ele)}
            placeholder={"Designation: All"}
            options={designationList.map((i) => ({
              label: i.designation_title,
              value: i.id,
            }))}
            components={{ DropdownIndicator }}
            className="custom-select-container"
            onChange={(e) =>
              handleSetEmpFilter(e?.value, FILTER_CONSTS.designation)
            }
          />
          <Select
            ref={(ele) => (selectBoxRef.current["Department"] = ele)}
            placeholder={"Department: All"}
            options={departmentList.map((i) => ({
              label: i.department_name,
              value: i.id,
            }))}
            components={{ DropdownIndicator }}
            className="custom-select-container"
            onChange={(e) => {
              handleSetEmpFilter(e.value, FILTER_CONSTS.department);
            }}
          />
          <Select
            ref={(ele) => (selectBoxRef.current["Ofiice"] = ele)}
            placeholder={"Office: All"}
            options={locationList.map((i) => ({
              label: i.location_name,
              value: i.id,
            }))}
            components={{ DropdownIndicator }}
            className="custom-select-container"
            onChange={(e) => {
              handleSetEmpFilter(e.value, FILTER_CONSTS.office);
            }}
          />
             <Select
                            ref={(ele) =>
                              (selectBoxRef.current["Employement Status"] = ele)
                            }
                            placeholder={"Active"}
                            options={[
                              { label: "Employeement Status: All", value: null },
                              ...employementStatus,
                            ]}
                            components={{ DropdownIndicator }}
                            className="custom-select-container"
                            onChange={(e) => {
                              handleSetEmpFilter(e.value, FILTER_CONSTS.accountStatus);
                            }}
                          />
          {!!isFilterApplied && (
            <button
              className="text-blue-600 cursor-pointer"
              onClick={handleClearFilters}
            >
              Clear filters
            </button>
          )}
        </div>

        <div className="flex">
          <div>
            <Search
              eleRef={searchBoxRef}
              onChange={(e) => handleSetEmpFilter(e, FILTER_CONSTS.filter)}
            />
          </div>

          {/* <a href="" className="btn btn--border text-[14px]">
            <span>
              <i className="ico-download mr-1"></i>
            </span>
            Download
          </a> */}
        </div>
      </div>
      <div>
        {isEmployeeDataLoading ? (
          <PageLoader />
        ) : Array.isArray(employeeList) && employeeList.length > 0 ? (
          <DirectoryCard
            data={employeeList}
            handleSelectEmployee={handleSelectEmployee}
            selectedEmployees={selectedEmployees}
          />
        ) : (
          <EmptyState />
        )}
        {Array.isArray(employeeList) && employeeList.length > 0 && (
          <Pagination
            page={{
              pageNo: pageNo,
              setPageNo: setPageNo,
              pageSize: pageSize,
              setPageSize: setPageSize,
              totalRecords,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Directory;
